module.exports = __webpack_public_path__ + "static/media/slideshow-foto-01.abfadbec.png";